import { toast } from 'react-toastify';

import soundSuccess from '../resources/sounds/success.mp3';
import soundError from '../resources/sounds/error.mp3';
import soundInfo from '../resources/sounds/info.mp3';

const twitterSuccess = new Audio(soundSuccess);
const twitterError = new Audio(soundError);
const twitterInfo = new Audio(soundInfo);

const toastTypes = {
  default: {
    type: toast.TYPE.DEFAULT,
    sound: twitterInfo,
  },
  success: {
    type: toast.TYPE.SUCCESS,
    sound: twitterSuccess,
  },
  error: {
    type: toast.TYPE.ERROR,
    sound: twitterError,
  },
  info: {
    type: toast.TYPE.INFO,
    sound: twitterInfo,
  },
  warn: {
    type: toast.TYPE.WARNING,
    sound: twitterInfo,
  },
};

const toaster = (message, baseType = 'default') => {
  const { type, sound } =
    toastTypes[baseType] && toastTypes[baseType].type
      ? toastTypes[baseType]
      : toastTypes.default;

  toast(message, { type });
  setTimeout(() => {
    sound.play();
  }, 200);
};

export default {
  default: (message) => toaster(message),
  success: (message) => toaster(message, 'success'),
  error: (message) => toaster(message, 'error'),
  info: (message) => toaster(message, 'info'),
  warn: (message) => toaster(message, 'warn'),
};
